import styled from '@emotion/styled';
import { Box, Grid, Paper, Rating, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import ShippingIcon from './ShippingIcon';
import ListingTypeBadge from '../DetailPanel/ListingTypeBadge';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CatalogBadge from './CatalogBadge';
import LightTooltip from 'views/Components/Shared/Components/LightTooltip';
import RankingDetail from '../DetailPanel/RankingDetail';

const StyledLink = styled('a')`
	color: #00000080;
	text-decoration: none; /* Remove underline */
	&:hover,
	&:focus {
		color: inherit; /* Optional: Change hover color */
		text-decoration: none; /* Optional: Change hover text decoration */
	}
	font-family: Roboto;
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 22px; /* 169.231% */
	letter-spacing: 0.46px;
	text-transform: uppercase;
`;

const StyledImage = styled.img`
	width: 60px;
	height: 60px;
	padding: 10px;
	border: 1px solid #0000003b;
`;

function DetailCard({ item }) {
	const isMeli = !item.site || item.site === 'MELI';
	return (
		<Paper
			sx={{
				width: '400px',
				padding: '8px',
			}}
		>
			<Grid container rowSpacing={1} columnSpacing={2}>
				<Grid item xs={3}>
					{isMeli && <CatalogBadge isCatalog={item.cataloglisting} />}
				</Grid>

				<Grid item xs={9}>
					<Stack
						direction="row"
						spacing={1}
						alignItems="center"
						sx={{
							color: '#575757',
							fontSize: '10px',
							fontWeight: '400',
							fontFamily: 'Roboto',
							fontStyle: 'normal',
							lineHeight: 'normal',
							width: 'fit-content',
						}}
					>
						<Typography>{item.itemid}</Typography> <Typography>|</Typography>
						<Typography
							sx={{
								width: 'fit-content',
							}}
						>
							SKU {item.sku}
						</Typography>
						<ContentCopyIcon
							onClick={() => navigator.clipboard.writeText(item.sku)}
							sx={{
								fill: '#5757578F',
								cursor: 'pointer',
								width: '16px',
								height: '16px',
							}}
						/>
					</Stack>
				</Grid>
				<Grid item xs={3}>
					<StyledImage src={item.thumbnail} alt="item" />
				</Grid>
				<Grid item xs={9}>
					<Stack spacing={1}>
						<Typography
							sx={{
								color: '#1F2937',
								fontSize: '14px',
								fontWeight: '500',
								fontFamily: 'Roboto',
								fontStyle: 'normal',
								lineHeight: '143%',
								letterspacing: '0.17px',
							}}
						>
							{item.title}
						</Typography>

						{/* Rating */}
						{isMeli && (
							<>
								<Stack direction="row" spacing={1} alignItems="center">
									<Typography
										sx={{
											color: '#575757',
											fontFamily: 'Roboto',
											fontStyle: 'normal',
											fontSize: '14px',
											lineHeight: '20px',
											fontWeight: '400',
										}}
									>
										{item.ratingaverage || 0}
									</Typography>

									<Rating
										value={item.ratingaverage || 0}
										readOnly
										size="small"
									/>

									<Typography
										sx={{
											color: '#575757',
											fontFamily: 'Roboto',
											fontStyle: 'normal',
											fontSize: '14px',
											lineHeight: '20px',
											fontWeight: '400',
										}}
									>
										({item.ratingtotal || 0})
									</Typography>
								</Stack>

								{/* Mas Vendidos */}

								<Typography
									sx={{
										color: '#1E88E5',
										fontFamily: 'Roboto',
										fontStyle: 'normal',
										fontSize: '12px',
										lineHeight: '143%',
										letterspacing: '0.17px',
										fontWeight: '400',
									}}
								>
									{/* Work in progress */}
									<RankingDetail ranking={item.ranking ? item.ranking : null} />
								</Typography>

								<ShippingIcon shipping={item.logistictype} />

								<ListingTypeBadge
									listingType={item.listingtypename}
									tags={item.tags}
								/>
							</>
						)}

						<Typography
							sx={{
								color: '#575757',
								fontFamily: 'Roboto',
								fontStyle: 'normal',
								fontSize: '12px',
								lineHeight: 'normal',
								fontWeight: '400',
							}}
						>
							{item.availablequantity} unidades
						</Typography>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
							}}
						>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									gap: '4px',
								}}
							>
								<StyledLink href={item.permalink} target="_blank">
									{isMeli ? 'IR A LA PUBLICACIÓN' : 'IR AL PRODUCTO'}
								</StyledLink>
								<ArrowForwardIcon
									sx={{
										fill: '#5757578F',
										cursor: 'pointer',
										width: '18px',
										height: '18px',
									}}
								/>
							</Box>
						</Box>
					</Stack>
				</Grid>
			</Grid>
		</Paper>
	);
}

export default function HoverDetailCard({ children, item }) {
	return (
		<LightTooltip title={<DetailCard item={item} />}>{children}</LightTooltip>
	);
}
